var app = app || {};

app.tabs = (function ($) {

	tabsInit = function() {
        $(".tabs__tab").click(function( e ) {
            var tab = $(this).attr("href");
            var pos = $(this).position();

            newTop = parseInt(pos.top) - 12;
            newHeight = parseInt($(this).outerHeight())+23;
            group = $(this).data('tab');

            //update both the accordion and tab links
            $("[data-tab='" + group + "']").addClass("tabs__tab--active");
            $("[data-tab='" + group + "']").siblings().removeClass("tabs__tab--active");

            // show the right content block
            $(".tabs__content").not(tab).removeClass('tabs__content--active');
            $(tab).addClass('tabs__content--active');
            
            var tabPos = $(this).offset();
            var windowPos = $(window).scrollTop();

            // if the tabs are in accordion format and the top you've just selected is now off page, move to it..
            if($(this).hasClass('tabs__tab--accordion') && tabPos.top < windowPos ) {
                var menuHeight = $('.brand').outerHeight();
                var scrollPos = tabPos.top - menuHeight;                     
                $("html, body").animate({scrollTop: scrollPos });
            }

            //move the highlight block
            $('.tabs__highlight').css({'top': newTop + 'px', height: newHeight});
            
            e.preventDefault();
        });
	},
    tabsResize = function() {
        $(window).on("debouncedresize", function( event ) {
            if($(".tabs").length) {
                var pos = $('.tabs__tab--active').position();
                newTop = parseInt(pos.top) - 12;
                newHeight = parseInt($('.tabs__tab--active').outerHeight())+23;
                $('.tabs__highlight').css({'top': newTop + 'px', height: newHeight});                
            }
        });
    },
    init = function () {
    	tabsInit();
        tabsResize();
    };
    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.tabs.init);